import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { Common } from '../../utils/constants';
import { companyNameReplace } from '../../utils';
import { Can } from '../../ability';
import DriverPremiumSubscriptionsGrid from './DriverSubscriptionsGrid';
import { IFilterState } from '../../types/stateTypes';

const DriverSubscriptions = () => {
    const { t } = useTranslation();
    const [filterState, setFilterState] = useState<IFilterState>({
        rowsPerPage: 10,
        currentPage: 1,
        sortColumn: 'start_date',
        sortOrder: 'desc',
        offset: 0,
    });

    return (
        <>
            <Helmet>
                <title>{companyNameReplace(t('driverSubscriptions.title'))}</title>
            </Helmet>
            <Can I={Common.Actions.MANAGE_PREMIUM_SUBSCRIPTIONS} a={Common.Modules.DRIVERS.ACCOUNTS}>
                <DriverPremiumSubscriptionsGrid setFilterState={setFilterState} filterState={filterState} />
            </Can>
        </>
    );
};

export default DriverSubscriptions;
